import React from 'react';
import {getUrl, PWAUrls} from "../config/urls";
import {setGlobalError} from "../actions";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import AlertComponent from "./AlertComponent";
import useLogError from "../hooks/useLogError";

class ErrorHandler extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isDev: true,
            error: null,
        }
    }

    componentDidCatch(error, info) {
        this.props.setGlobalError(true);
        this.setState({error:error});
        console.log('ErrorHandler componentDidCatch');
        console.error(error);
        this.logError(error, info);
    }

    logError(error, info) {
        try {
            let trace = error.toString();

            if (typeof error.stack !== 'undefined') {
                trace = error.stack;
            } else {
                if (info && typeof info.componentStack !== 'undefined') {
                    trace += ' ' + info.componentStack;
                }
            }

            this.setState({error:error});

            useLogError({
                'trace': trace,
                'url': window.location.href,
                'state': localStorage.getItem('state'),
                'email': this.props.email
            }, this.props.language);
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const {t, i18n} = this.props;

        if (this.props.errorOccured) {
            return <AlertComponent
                title={t("ErrorHandler.message")}
                message={null}
                severity={"error"}
                reload={true}
                ctaIcon={"home"}
                ctaLinkTo={getUrl(PWAUrls.HOME, {lng: i18n.language})}
                ctaLabel={t("ErrorHandlerRoute.home")}
                backgroundIcon={"person-falling-burst"}
                showOnline={true}
            />
        }

         return this.props.children;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        errorOccured: typeof state.common.errorOccured !== 'undefined' ? state.common.errorOccured : false,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setGlobalError: (hasError) => {
            dispatch(setGlobalError(hasError))
        },
    }
}

export default
    compose(
        withTranslation(),
        connect(
            mapStateToProps,
            mapDispatchToProps
        ))(ErrorHandler);